const Accessories = [
  {
    category: "accessories",
    subcategory: "Chapeaux & Bonnets",
    name:
      "Masques d'isolation de protection du visage Masques anti-buée anti-éclaboussures",
    price: "9.99",
    raw_price: "16.99",
    currency: "USD",
    discount: "41",
    likes_count: "373",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Gray",
    variation_1_color: "Blue",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/09/FD/e8204e98-8e30-41ca-a599-c8ed90469e08.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/09/FD/e8204e98-8e30-41ca-a599-c8ed90469e08.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/2E/72/1c322075-7a7a-474d-976e-6bcbc45daaec.jpg",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/2E/72/1c322075-7a7a-474d-976e-6bcbc45daaec.jpg",
    url: "https://fr.newchic.com/hats-and-caps-4192/p-1671872.html",
    id: "1671872",
    model: "SKUF08305",
  },
  {
    category: "accessories",
    subcategory: "Baseball Caps",
    name:
      "Chapeau de parasol de casquette de baseball en denim lavé à bordure personnalisée en plein air",
    price: "9.99",
    raw_price: "18.99",
    currency: "USD",
    discount: "47",
    likes_count: "73",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Navy",
    variation_1_color: "Black",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/45/ED/2e7729ff-3dde-4f1c-9ece-d6c2a5f24302.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/45/ED/2e7729ff-3dde-4f1c-9ece-d6c2a5f24302.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/79/30/9b8eb997-55d4-4e67-8b89-e81178cf2e8e.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/79/30/9b8eb997-55d4-4e67-8b89-e81178cf2e8e.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/0D/0D/a735a697-871f-4bea-b92d-19947ff8f328.jpg",
    url: "https://fr.newchic.com/baseball-caps-12158/p-1674377.html",
    id: "1674377",
    model: "SKUF11351",
  },
  {
    category: "accessories",
    subcategory: "Flat Caps",
    name: "Casquette Gavroche Cabbie Lvy Flat Hat Vintage Painter Beret Hats ",
    price: "17.49",
    raw_price: "37.34",
    currency: "USD",
    discount: "53",
    likes_count: "140",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "camel",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/A4/2F/42467cfd-63b4-4f6e-901c-90dc34cd52b3.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/A4/2F/42467cfd-63b4-4f6e-901c-90dc34cd52b3.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/30/CE/5f9c589f-81f7-48c4-a24c-4ba41cdf3718.jpg",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/30/CE/5f9c589f-81f7-48c4-a24c-4ba41cdf3718.jpg",
    url: "https://fr.newchic.com/flat-caps-12160/p-1637790.html",
    id: "1637790",
    model: "SKUE50978",
  },
  {
    category: "accessories",
    subcategory: "Cache-oreilles & Masques",
    name: "Masque à fleurs en coton multicolore Masque vintage",
    price: "5.99",
    raw_price: "16.01",
    currency: "USD",
    discount: "63",
    likes_count: "686",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "#01",
    variation_1_color: "#02",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/39/4F/db60e479-87f5-4a82-94cb-ec17b4e772a4.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/39/4F/db60e479-87f5-4a82-94cb-ec17b4e772a4.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/D2/B6/0179fdce-340b-4da5-b89b-e49a7ec39d17.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/D2/B6/0179fdce-340b-4da5-b89b-e49a7ec39d17.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/E6/1D/834076a4-45ea-476c-8f45-bbe1b95db3d7.jpg",
    url:
      "https://fr.newchic.com/earmuffsandmouth-maskandblindfold-6011/p-1654953.html",
    id: "1654953",
    model: "SKUE76490",
  },
  {
    category: "accessories",
    subcategory: "Chapeaux & Bonnets",
    name: "Chapeau de pêche en plein air pour hommes",
    price: "13.99",
    raw_price: "26.99",
    currency: "USD",
    discount: "48",
    likes_count: "35",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "Army Green",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/B4/B2/c4ac4148-67fe-43ed-af4e-6552b43dbb65.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/B4/B2/c4ac4148-67fe-43ed-af4e-6552b43dbb65.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/EF/CC/b59a7048-a07f-4f95-a307-67d3a75b6c76.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/EF/CC/b59a7048-a07f-4f95-a307-67d3a75b6c76.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/66/A2/1c551fef-742d-4381-8e99-9924622b3c24.jpg",
    url: "https://fr.newchic.com/hats-and-caps-4192/p-1666600.html",
    id: "1666600",
    model: "SKUE75375",
  },
  {
    category: "accessories",
    subcategory: "Beanie Hat",
    name:
      "Femmes Imprimer Campagne Floral Twist Beanie Cap Turban Cap de chimiothérapie",
    price: "9.99",
    raw_price: "18.99",
    currency: "USD",
    discount: "47",
    likes_count: "91",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Leopard",
    variation_1_color: "Green",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/72/F6/51a42b56-1fd9-43e8-b58d-25996157d112.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/72/F6/51a42b56-1fd9-43e8-b58d-25996157d112.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/5C/7F/af9a1ad2-952e-47db-b701-6a186799bc39.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/5C/7F/af9a1ad2-952e-47db-b701-6a186799bc39.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/76/61/bf57ee2a-fd11-46fd-86ab-4bbabf79b458.jpg",
    url: "https://fr.newchic.com/beanie-hat-12168/p-1690702.html",
    id: "1690702",
    model: "SKUF28537",
  },
  {
    category: "accessories",
    subcategory: "Cache-oreilles",
    name: "Visage floral Masque Sheild Masque en coton vintage",
    price: "5.99",
    raw_price: "11.99",
    currency: "USD",
    discount: "50",
    likes_count: "147",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/24/A2/130196fb-f98a-4495-b8d5-a4acdc423843.JPG",

    variation_1_thumbnail: "",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/7A/DE/64d683af-9417-45fe-9f2d-73c894a82e69.jpg",
    image_url: "",
    url:
      "https://fr.newchic.com/earmuffsandmouth-maskandblindfold-6010/p-1668210.html",
    id: "1668210",
    model: "SKUE94427",
  },
  {
    category: "accessories",
    subcategory: "Chapeaux & Bonnets",
    name:
      "Bonnet en coton brodé pour homme Chapeau avant Chapeau de soleil rétro britannique Béret littéraire",
    price: "12.99",
    raw_price: "23.99",
    currency: "USD",
    discount: "46",
    likes_count: "46",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "Navy",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/03/44/b299ecc6-b0e3-4974-9d7f-f5eb29e5dd64.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/03/44/b299ecc6-b0e3-4974-9d7f-f5eb29e5dd64.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/02/DB/2313f528-1cd0-416e-becb-9083e1784040.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/02/DB/2313f528-1cd0-416e-becb-9083e1784040.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/3A/60/567b9a0a-66e3-4fdb-ad99-4155400c8714.jpg",
    url: "https://fr.newchic.com/hats-and-caps-4192/p-1674357.html",
    id: "1674357",
    model: "SKUF04432",
  },
  {
    category: "accessories",
    subcategory: "Flat Caps",
    name: "Casquette gavroche octogonale d'été Cabbie Lvy Flat Hat",
    price: "20.49",
    raw_price: "42.47",
    currency: "USD",
    discount: "52",
    likes_count: "121",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "Grey",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/90/58/edea7848-9302-4aab-b9fa-d9f66167121c.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/90/58/edea7848-9302-4aab-b9fa-d9f66167121c.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/C9/2E/dbb5e404-fcfe-493b-ad96-9e1adf312b80.jpg",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/C9/2E/dbb5e404-fcfe-493b-ad96-9e1adf312b80.jpg",
    url: "https://fr.newchic.com/flat-caps-12160/p-1637791.html",
    id: "1637791",
    model: "SKUE50991",
  },
  {
    category: "accessories",
    subcategory: "Skull Caps",
    name: "Casquettes de crâne pour hommes à carreaux sans bord assortis",
    price: "12.99",
    raw_price: "25.99",
    currency: "USD",
    discount: "50",
    likes_count: "71",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Yellow",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/E9/40/91f3eb62-404b-4b1f-a067-54c2b20599c8.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/E9/40/91f3eb62-404b-4b1f-a067-54c2b20599c8.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/6B/1B/bc093bb3-a13e-433d-baca-d0f2b0861671.jpg",
    url: "https://fr.newchic.com/skull-caps-12161/p-1690229.html",
    id: "1690229",
    model: "SKUF19523",
  },
  {
    category: "accessories",
    subcategory: "Ceintures & Bretelles",
    name:
      "Ceinture en cuir véritable pour hommes Ceinture décontractée Sangle de taille Broche lisse Ceinture rétro",
    price: "32.99",
    raw_price: "64.99",
    currency: "USD",
    discount: "49",
    likes_count: "35",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "Coffee",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/61/C4/b6926a8d-4e65-4bda-be19-decf9a21d775.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/61/C4/b6926a8d-4e65-4bda-be19-decf9a21d775.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/F1/65/0cced8e6-fdf9-4f58-8365-f3a5e9d10b1f.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/F1/65/0cced8e6-fdf9-4f58-8365-f3a5e9d10b1f.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/5B/31/5bb64099-7c96-46a2-ae69-acfafd5143cd.jpg",
    url: "https://fr.newchic.com/mens-belts-4189/p-1682316.html",
    id: "1682316",
    model: "SKUF26232",
  },
  {
    category: "accessories",
    subcategory: "Cache-oreilles",
    name: "Masque facial en mousseline respirant réglable ",
    price: "4.99",
    raw_price: "9.99",
    currency: "USD",
    discount: "50",
    likes_count: "110",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/7A/DE/64d683af-9417-45fe-9f2d-73c894a82e69.jpg",
    variation_1_thumbnail: "",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/FC/C8/2782935a-aa14-493e-af10-2ed01c0718b8.JPG",

    image_url: "",
    url:
      "https://fr.newchic.com/earmuffsandmouth-maskandblindfold-6010/p-1676041.html",
    id: "1676041",
    model: "SKUF09796",
  },
  {
    category: "accessories",
    subcategory: "Cache-oreilles & Masques",
    name: "Masque facial unisexe respirant de couleur unie",
    price: "4.99",
    raw_price: "9.99",
    currency: "USD",
    discount: "50",
    likes_count: "98",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "Gray",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/96/9D/4630250a-4cea-4c03-afc0-6696d57c5fc5.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/96/9D/4630250a-4cea-4c03-afc0-6696d57c5fc5.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/1D/FE/8532c3eb-9422-4f21-a304-35cedb428e39.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/1D/FE/8532c3eb-9422-4f21-a304-35cedb428e39.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/1E/75/7a888bf9-18f3-4ffc-b352-f41eea51a959.jpg",
    url:
      "https://fr.newchic.com/earmuffsandmouth-maskandblindfold-6011/p-1676042.html",
    id: "1676042",
    model: "SKUF09707",
  },
  {
    category: "accessories",
    subcategory: "Beanie Hat",
    name: "Elephant Retro Beanie Hat Turban Cap de chimiothérapie",
    price: "10.99",
    raw_price: "22.99",
    currency: "USD",
    discount: "52",
    likes_count: "108",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "Blue",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/24/00/fb1e2c60-89a8-4322-8f69-f926f7e3a407.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/24/00/fb1e2c60-89a8-4322-8f69-f926f7e3a407.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/41/32/991197bd-8f95-413a-b328-1a0b772174dd.jpg",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/41/32/991197bd-8f95-413a-b328-1a0b772174dd.jpg",
    url: "https://fr.newchic.com/beanie-hat-12168/p-1669588.html",
    id: "1669588",
    model: "SKUE92909",
  },
  {
    category: "accessories",
    subcategory: "Cache-oreilles",
    name: "Masque anti-poussière Masque floral visage Sheild",
    price: "5.99",
    raw_price: "11.99",
    currency: "USD",
    discount: "50",
    likes_count: "106",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/FC/C8/2782935a-aa14-493e-af10-2ed01c0718b8.JPG",

    variation_1_thumbnail: "",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/96/6A/f9a84ee8-bce1-46f2-bfa5-2fd5353ef6d5.jpg",
    image_url: "",
    url:
      "https://fr.newchic.com/earmuffsandmouth-maskandblindfold-6010/p-1668209.html",
    id: "1668209",
    model: "SKUE94426",
  },
  {
    category: "accessories",
    subcategory: "Chapeaux & Bonnets",
    name:
      "Chapeau élastique de chapeau de bonnet de chapeau élastique de couleur unie avec des boutons d'oreille",
    price: "6.99",
    raw_price: "13.99",
    currency: "USD",
    discount: "50",
    likes_count: "85",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Red",
    variation_1_color: "Beige",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/31/04/542460d3-2d59-49ae-a796-60f27c43dc50.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/31/04/542460d3-2d59-49ae-a796-60f27c43dc50.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/32/BD/96b56d8c-b9cc-4572-85b8-ec0292717ef3.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/32/BD/96b56d8c-b9cc-4572-85b8-ec0292717ef3.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/35/51/0b4e1a8b-9d69-47d7-a566-f1afe21207db.jpg",
    url: "https://fr.newchic.com/womens-hats-4124/p-1686029.html",
    id: "1686029",
    model: "SKUF28443",
  },
  {
    category: "accessories",
    subcategory: "Beanie Hat",
    name: "Bonnet Fleurs Bonnets Découpés En Relief",
    price: "10.99",
    raw_price: "22.99",
    currency: "USD",
    discount: "52",
    likes_count: "63",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Khaki",
    variation_1_color: "Black",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/6F/56/3ea1aa31-5c7e-4efe-8a19-f6bd14ec80c2.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/6F/56/3ea1aa31-5c7e-4efe-8a19-f6bd14ec80c2.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/33/BD/fe007048-4571-40ee-b478-70311f883f9d.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/33/BD/fe007048-4571-40ee-b478-70311f883f9d.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/4B/16/1fb6c5f1-7824-49c6-8033-a71528a99200.jpg",
    url: "https://fr.newchic.com/beanie-hat-12168/p-1694979.html",
    id: "1694979",
    model: "SKUF33483",
  },
  {
    category: "accessories",
    subcategory: "Skull Caps",
    name:
      "Chapeau de propriétaire pour homme Collrown Summer Street Trends Melon Cap Denim Chapeaux sans bord",
    price: "13.99",
    raw_price: "26.99",
    currency: "USD",
    discount: "48",
    likes_count: "53",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Blue",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/67/FE/de288b79-6a70-4264-b5f8-aeea01c8ac67.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/67/FE/de288b79-6a70-4264-b5f8-aeea01c8ac67.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/CB/D6/1f324811-3805-4cc2-9540-42e4f5002667.jpg",
    url: "https://fr.newchic.com/skull-caps-12161/p-1690613.html",
    id: "1690613",
    model: "SKUF24036",
  },
  {
    category: "accessories",
    subcategory: "Chapeaux & Bonnets",
    name: "Chapeau de pêche en plein air",
    price: "10.99",
    raw_price: "21.99",
    currency: "USD",
    discount: "50",
    likes_count: "58",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Army Green",
    variation_1_color: "Light Grey",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/65/94/9bea4924-9469-4b49-aa0e-c4e6d986ef4e.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/65/94/9bea4924-9469-4b49-aa0e-c4e6d986ef4e.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/38/54/2d750c6a-f4f4-4ca0-8c79-100b3c1b9e52.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/38/54/2d750c6a-f4f4-4ca0-8c79-100b3c1b9e52.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/57/C0/46399a72-3f9e-4880-a10a-f7e7c2b2c86d.jpg",
    url: "https://fr.newchic.com/hats-and-caps-4192/p-1680830.html",
    id: "1680830",
    model: "SKUF25633",
  },
  {
    category: "accessories",
    subcategory: "Gants",
    name: "Gants tactiques Handschuhe à écran tactile complet",
    price: "25.99",
    raw_price: "49.99",
    currency: "USD",
    discount: "48",
    likes_count: "53",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "Brown",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/0F/58/c7609e64-f82b-4c6f-9246-3f501ac18380.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/0F/58/c7609e64-f82b-4c6f-9246-3f501ac18380.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/A7/66/50bad48f-2b58-41fd-94be-450f9f0a1598.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/A7/66/50bad48f-2b58-41fd-94be-450f9f0a1598.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/57/8A/70ed0ba8-4163-4537-9f3f-dec22c8f1ddc.jpg",
    url: "https://fr.newchic.com/mens-gloves-4193/p-1691311.html",
    id: "1691311",
    model: "SKUF41075",
  },
  {
    category: "accessories",
    subcategory: "Baseball Caps",
    name:
      "Chapeau de parasol de casquette de baseball en denim lavé personnalisé pour hommes en plein air",
    price: "9.99",
    raw_price: "18.99",
    currency: "USD",
    discount: "47",
    likes_count: "20",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Navy",
    variation_1_color: "Black",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/6C/56/0ad56719-7aa3-4d99-9231-c34cfd224753.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/6C/56/0ad56719-7aa3-4d99-9231-c34cfd224753.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/71/74/209d4112-8e90-496e-bf3d-37357428f027.jpg",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/71/74/209d4112-8e90-496e-bf3d-37357428f027.jpg",
    url: "https://fr.newchic.com/baseball-caps-12158/p-1674376.html",
    id: "1674376",
    model: "SKUF11354",
  },
  {
    category: "accessories",
    subcategory: "Baseball Caps",
    name: "Casquette Trump 2020 Baseball Cap US Presidential Election",
    price: "14.99",
    raw_price: "28.99",
    currency: "USD",
    discount: "48",
    likes_count: "21",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/96/6A/f9a84ee8-bce1-46f2-bfa5-2fd5353ef6d5.jpg",
    variation_1_thumbnail: "",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/2E/76/41f43df8-90c4-4f2c-b030-0fd959b5ad04.jpg",

    image_url: "",
    url: "https://fr.newchic.com/baseball-caps-12158/p-1674134.html",
    id: "1674134",
    model: "SKUE94195",
  },
  {
    category: "accessories",
    subcategory: "Ceintures & Bretelles",
    name:
      "Ceinture pour hommes en cuir véritable ceinture givrée décontractée ceinture sangle broche ceinture rétro",
    price: "49.99",
    raw_price: "99.99",
    currency: "USD",
    discount: "50",
    likes_count: "10",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Green",
    variation_1_color: "Coffee",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/80/11/c3462521-47b5-4c37-b5c8-b1cb6c680ebf.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/80/11/c3462521-47b5-4c37-b5c8-b1cb6c680ebf.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/0B/11/d714b04d-16cb-448b-81bc-4f6d8a4c760b.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/0B/11/d714b04d-16cb-448b-81bc-4f6d8a4c760b.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/A6/85/0dbd16aa-54e6-401e-b17e-3278d934a75e.jpg",
    url: "https://fr.newchic.com/mens-belts-4189/p-1682449.html",
    id: "1682449",
    model: "SKUF26286",
  },
  {
    category: "accessories",
    subcategory: "Cache-oreilles",
    name: "Masque en coton imprimé Masque anti-poussière ",
    price: "5.99",
    raw_price: "11.99",
    currency: "USD",
    discount: "50",
    likes_count: "97",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Blue",
    variation_1_color: "Pink",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/FA/BA/433c34fb-3fa2-4cad-b827-5ff38a9c7364.JPG",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/FA/BA/433c34fb-3fa2-4cad-b827-5ff38a9c7364.JPG",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/B7/E2/a7146c65-c870-4cba-a272-bc460ea9c2fa.JPG",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/B7/E2/a7146c65-c870-4cba-a272-bc460ea9c2fa.JPG",
    url:
      "https://fr.newchic.com/earmuffsandmouth-maskandblindfold-6010/p-1668212.html",
    id: "1668212",
    model: "SKUE94424",
  },
  {
    category: "accessories",
    subcategory: "Cache-oreilles",
    name: "Masque de décoration de diamant pour femmes Masque Sheild",
    price: "6.99",
    raw_price: "0",
    currency: "USD",
    discount: "0",
    likes_count: "30",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "# 01",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/55/DD/d95304cd-19dd-477e-b939-9576d1ec2cc2.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/55/DD/d95304cd-19dd-477e-b939-9576d1ec2cc2.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/7A/80/ee869a29-071b-4844-b7ec-8c8b8aae1fce.jpg",
    url:
      "https://fr.newchic.com/earmuffsandmouth-maskandblindfold-6010/p-1695105.html",
    id: "1695105",
    model: "SKUF38828",
  },
  {
    category: "accessories",
    subcategory: "Beanie Hat",
    name: "Chapeau de gommage pour casquettes chirurgicales",
    price: "11.49",
    raw_price: "21.73",
    currency: "USD",
    discount: "47",
    likes_count: "30",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Gray",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/87/7D/788d358f-89ed-4011-810f-5f5bcbdcdd43.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/87/7D/788d358f-89ed-4011-810f-5f5bcbdcdd43.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/2E/76/41f43df8-90c4-4f2c-b030-0fd959b5ad04.jpg",
    url: "https://fr.newchic.com/beanie-hat-12168/p-1662888.html",
    id: "1662888",
    model: "SKUE95123",
  },
  {
    category: "accessories",
    subcategory: "Cache-oreilles",
    name: "Masque Sheild visage floral femme ",
    price: "5.99",
    raw_price: "11.99",
    currency: "USD",
    discount: "50",
    likes_count: "126",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/2E/76/41f43df8-90c4-4f2c-b030-0fd959b5ad04.jpg",

    variation_1_thumbnail: "",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/10/66/0a9f3b22-5012-4037-b18a-ddbec814256d.jpg",

    image_url: "",
    url:
      "https://fr.newchic.com/earmuffsandmouth-maskandblindfold-6010/p-1668213.html",
    id: "1668213",
    model: "SKUE94428",
  },
  {
    category: "accessories",
    subcategory: "Cache-oreilles",
    name:
      "Masque de décoration de femmes pour masque de mode de soirée de danse",
    price: "6.99",
    raw_price: "0",
    currency: "USD",
    discount: "0",
    likes_count: "45",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "# 01",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/77/9E/dc710cd2-9289-4d56-9fed-50dccb7b9373.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/77/9E/dc710cd2-9289-4d56-9fed-50dccb7b9373.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/8A/F5/37bd330d-d958-40da-9177-a47637fcfd4e.jpg",
    url:
      "https://fr.newchic.com/earmuffsandmouth-maskandblindfold-6010/p-1695114.html",
    id: "1695114",
    model: "SKUF38928",
  },
  {
    category: "accessories",
    subcategory: "Flat Caps",
    name: "Casquette Gavroche en Laine Cabbie Lvy Flat Hat Beret Hats ",
    price: "17.49",
    raw_price: "29.26",
    currency: "USD",
    discount: "40",
    likes_count: "60",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/B6/6F/71f92631-51cf-4ccc-b455-3c3eb18dbc6a.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/B6/6F/71f92631-51cf-4ccc-b455-3c3eb18dbc6a.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/10/66/0a9f3b22-5012-4037-b18a-ddbec814256d.jpg",
    url: "https://fr.newchic.com/flat-caps-12160/p-1637789.html",
    id: "1637789",
    model: "SKUE50982",
  },
  {
    category: "accessories",
    subcategory: "Beanie Hat",
    name: "Bonnet à rayures multicolore Bonnet écharpe Turban Head Wrap Cap ",
    price: "7.99",
    raw_price: "14.99",
    currency: "USD",
    discount: "47",
    likes_count: "43",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/10/66/0a9f3b22-5012-4037-b18a-ddbec814256d.jpg",

    variation_1_thumbnail: "",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/E8/0A/d499df50-c349-45ea-8a44-eb4cfe5c2c0a.jpg",
    image_url: "",
    url: "https://fr.newchic.com/beanie-hat-12168/p-1676014.html",
    id: "1676014",
    model: "SKUF16169",
  },
  {
    category: "accessories",
    subcategory: "Chapeaux & Bonnets",
    name:
      "Casquette de baseball rétro chapeaux de broderie de chapeau de soleil rétro",
    price: "11.99",
    raw_price: "20",
    currency: "USD",
    discount: "40",
    likes_count: "19",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Khaki",
    variation_1_color: "Black",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/73/95/9f95d8d5-a66d-43e7-9308-8f3df3d1ae6e.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/73/95/9f95d8d5-a66d-43e7-9308-8f3df3d1ae6e.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/F6/5A/c61bac6c-f68a-4518-8946-eddc58224fe5.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/F6/5A/c61bac6c-f68a-4518-8946-eddc58224fe5.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/70/F9/407043d0-9c15-4fcc-ad23-f42a798a3035.jpg",
    url: "https://fr.newchic.com/hats-and-caps-4192/p-1679096.html",
    id: "1679096",
    model: "SKUF23906",
  },
  {
    category: "accessories",
    subcategory: "Foulards & Écharpes",
    name: "Multifarben Color Block Cotton Blend Femme Foulards & Châles",
    price: "28.74",
    raw_price: "71.68",
    currency: "USD",
    discount: "60",
    likes_count: "236",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "#01",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/7E/B8/b1b7c477-25ec-463b-92a8-7ca759078291.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/7E/B8/b1b7c477-25ec-463b-92a8-7ca759078291.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/DA/F7/e6ad43a6-59ff-4b46-a97c-6faaf87813ad.jpeg",
    url: "https://fr.newchic.com/womens-scarves-4127/p-1565548.html",
    id: "1565548",
    model: "SKUD51316",
  },
  {
    category: "accessories",
    subcategory: "Headband & Bandeaux",
    name:
      "Masque de bandeau élastique Bandeau de bouton anti-cuir Bandeau de sport absorbant la sueur",
    price: "4.99",
    raw_price: "8.99",
    currency: "USD",
    discount: "45",
    likes_count: "58",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "#01",
    variation_1_color: "#02",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/64/79/8f6955f6-bd82-498f-8cbd-692f8e071ecf.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/64/79/8f6955f6-bd82-498f-8cbd-692f8e071ecf.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/04/B7/cc7e9ac8-23de-41e3-9cfa-12472ddd34b3.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/04/B7/cc7e9ac8-23de-41e3-9cfa-12472ddd34b3.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/ED/BA/b3e38bfb-268b-4879-b11e-93ed97d5715a.jpg",
    url: "https://fr.newchic.com/headband-7235/p-1686032.html",
    id: "1686032",
    model: "SKUF28417",
  },
  {
    category: "accessories",
    subcategory: "Chapeaux & Bonnets",
    name: "Plaque télescopique à tirer",
    price: "11.99",
    raw_price: "23.99",
    currency: "USD",
    discount: "50",
    likes_count: "52",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Navy",
    variation_1_color: "Pink",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/86/34/32269ae0-da4e-49ea-be65-b28cb6ddc484.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/86/34/32269ae0-da4e-49ea-be65-b28cb6ddc484.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/79/E2/857906c4-5348-4f10-8def-59d932dbc32e.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/79/E2/857906c4-5348-4f10-8def-59d932dbc32e.jpg",
    image_url: "",
    url: "https://fr.newchic.com/womens-hats-4124/p-1674846.html",
    id: "1674846",
    model: "SKUF06912",
  },
  {
    category: "accessories",
    subcategory: "Chapeaux & Bonnets",
    name:
      "Casquette de baseball à la mode Chapeau de soleil rétro Chapeaux de broderie de coton",
    price: "11.99",
    raw_price: "23.99",
    currency: "USD",
    discount: "50",
    likes_count: "21",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Khaki",
    variation_1_color: "Black",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/DD/EB/41a77998-9113-4935-8900-c76859479c96.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/DD/EB/41a77998-9113-4935-8900-c76859479c96.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/79/F5/d22369c9-e9c2-40c7-8fa7-0935800d3a27.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/79/F5/d22369c9-e9c2-40c7-8fa7-0935800d3a27.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/62/5C/d1009442-4b8a-432b-80a3-35e61a0b352d.jpg",
    url: "https://fr.newchic.com/hats-and-caps-4192/p-1679074.html",
    id: "1679074",
    model: "SKUF23801",
  },
  {
    category: "accessories",
    subcategory: "Cache-oreilles",
    name: "Masque ajustable en mousseline imprimée",
    price: "4.99",
    raw_price: "9.99",
    currency: "USD",
    discount: "50",
    likes_count: "34",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/E8/0A/d499df50-c349-45ea-8a44-eb4cfe5c2c0a.jpg",
    variation_1_thumbnail: "",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/71/95/ce0803ce-679c-4c00-aa85-cda5e2d68442.jpg",
    image_url: "",
    url:
      "https://fr.newchic.com/earmuffsandmouth-maskandblindfold-6010/p-1676046.html",
    id: "1676046",
    model: "SKUF09784",
  },
  {
    category: "accessories",
    subcategory: "Chapeaux & Bonnets",
    name: "COLLROWN Casquettes de béret de peintre en coton brodé pour hommes",
    price: "13.99",
    raw_price: "27.99",
    currency: "USD",
    discount: "50",
    likes_count: "8",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "kaki",
    variation_1_color: "armée verte",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/54/FD/c6678e90-0b96-4356-83f1-973c923fdaab.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/54/FD/c6678e90-0b96-4356-83f1-973c923fdaab.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/AB/68/e88b2e40-d68f-445e-9435-49fc625afeb8.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/AB/68/e88b2e40-d68f-445e-9435-49fc625afeb8.jpg",
    image_url: "",
    url: "https://fr.newchic.com/hats-and-caps-4192/p-1690110.html",
    id: "1690110",
    model: "SKUF19507",
  },
  {
    category: "accessories",
    subcategory: "Baseball Caps",
    name: "Casquette de baseball Trump Election 2020 US",
    price: "8.99",
    raw_price: "16.99",
    currency: "USD",
    discount: "47",
    likes_count: "9",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/71/95/ce0803ce-679c-4c00-aa85-cda5e2d68442.jpg",
    variation_1_thumbnail: "",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/A9/5D/05d1fd51-647b-472b-ad94-4f170ed55b56.jpg",

    image_url: "",
    url: "https://fr.newchic.com/baseball-caps-12158/p-1674138.html",
    id: "1674138",
    model: "SKUE94307",
  },
  {
    category: "accessories",
    subcategory: "Beanie Hat",
    name: "Bonnet papillon Bonnet de chimiothérapie Cap Turban",
    price: "11.99",
    raw_price: "24.99",
    currency: "USD",
    discount: "52",
    likes_count: "29",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "",
    variation_0_color: "Black",
    variation_1_color: "Navy",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/19/8A/40be41d6-b5e1-4d83-b340-f3377ee11bb1.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/19/8A/40be41d6-b5e1-4d83-b340-f3377ee11bb1.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/48/3A/587a3681-230e-426a-a2f9-3ed1c98ccd60.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/48/3A/587a3681-230e-426a-a2f9-3ed1c98ccd60.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/5C/48/e3217b50-0eab-49ff-9855-164358324f8c.jpg",
    url: "https://fr.newchic.com/beanie-hat-12168/p-1677731.html",
    id: "1677731",
    model: "SKUF19129",
  },
  {
    category: "accessories",
    subcategory: "Flat Caps",
    name: "Casquette Gavroche Coton Cabbie Lvy Flat Hat Vintage Beret",
    price: "17.49",
    raw_price: "27.68",
    currency: "USD",
    discount: "37",
    likes_count: "53",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/69/23/b7c7dcdd-a794-4253-aa15-d02c7afe9766.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/69/23/b7c7dcdd-a794-4253-aa15-d02c7afe9766.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/A9/5D/05d1fd51-647b-472b-ad94-4f170ed55b56.jpg",
    url: "https://fr.newchic.com/flat-caps-12160/p-1637788.html",
    id: "1637788",
    model: "SKUE51001",
  },
  {
    category: "accessories",
    subcategory: "Chapeaux & Bonnets",
    name: "Béret en coton pour hommes",
    price: "11.99",
    raw_price: "23.99",
    currency: "USD",
    discount: "50",
    likes_count: "21",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "Gray",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/15/EC/bf896a4f-ef9d-4314-bedd-6ca468cb1504.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/15/EC/bf896a4f-ef9d-4314-bedd-6ca468cb1504.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/A9/5D/05d1fd51-647b-472b-ad94-4f170ed55b56.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/A9/5D/05d1fd51-647b-472b-ad94-4f170ed55b56.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/BE/EC/ff1cea6c-8912-4e33-97bf-76166491ff96.jpg",
    url: "https://fr.newchic.com/hats-and-caps-4192/p-1681952.html",
    id: "1681952",
    model: "SKUF04434",
  },
  {
    category: "accessories",
    subcategory: "Beanie Hat",
    name: "Chapeau ethnique floral brodé vintage pour femme ",
    price: "20.99",
    raw_price: "40.99",
    currency: "USD",
    discount: "49",
    likes_count: "41",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/3F/D5/ffa164c3-bb85-4799-91aa-ea1123acb097.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/3F/D5/ffa164c3-bb85-4799-91aa-ea1123acb097.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/78/62/62399b87-e110-427a-82d2-dac8a5277b1a.jpg",
    url: "https://fr.newchic.com/beanie-hat-12168/p-1676007.html",
    id: "1676007",
    model: "SKUF16119",
  },
  {
    category: "accessories",
    subcategory: "Beanie Hat",
    name: "Printed Lace Stitching Beanie Scarf Hat Dual-use Turban Cap",
    price: "11.99",
    raw_price: "23.99",
    currency: "USD",
    discount: "50",
    likes_count: "41",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Gray",
    variation_1_color: "Red",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/A1/0A/b4469204-742d-4c44-ad24-b5d421d13283.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/A1/0A/b4469204-742d-4c44-ad24-b5d421d13283.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/78/62/62399b87-e110-427a-82d2-dac8a5277b1a.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/78/62/62399b87-e110-427a-82d2-dac8a5277b1a.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/DA/EF/9489e4bc-46eb-49c7-bfd2-c428e837c0e7.jpg",
    url: "https://fr.newchic.com/beanie-hat-12168/p-1677733.html",
    id: "1677733",
    model: "SKUF19153",
  },
  {
    category: "accessories",
    subcategory: "Baseball Caps",
    name:
      "Hommes femmes rue hip hop casquette de baseball dessin animé avion en plein air ombre casquette de baseball",
    price: "10.99",
    raw_price: "15.99",
    currency: "USD",
    discount: "31",
    likes_count: "12",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Yellow",
    variation_1_color: "White",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/BF/B5/29c88874-279b-4c18-bd91-6e2f1f05386f.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/BF/B5/29c88874-279b-4c18-bd91-6e2f1f05386f.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/AC/FE/4ad3bbdc-2368-48d7-8b92-580396d21ab6.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/AC/FE/4ad3bbdc-2368-48d7-8b92-580396d21ab6.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/64/8E/1993a967-6da8-4d71-83c6-fd40c4dba88f.jpg",
    url: "https://fr.newchic.com/baseball-caps-12158/p-1701892.html",
    id: "1701892",
    model: "SKUF45993",
  },
  {
    category: "accessories",
    subcategory: "Chapeaux & Bonnets",
    name: "Chapeau de soleil enfant Big-edge Outdoor Anti-UV ",
    price: "14.99",
    raw_price: "29.99",
    currency: "USD",
    discount: "50",
    likes_count: "36",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "Orange",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/90/A6/00d66da7-124e-46cf-9529-0a99d90321b0.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/90/A6/00d66da7-124e-46cf-9529-0a99d90321b0.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/DD/6C/975fa6b1-b68f-4360-bef2-ec4fb9ce3259.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/DD/6C/975fa6b1-b68f-4360-bef2-ec4fb9ce3259.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/EF/E2/1058c1e4-e5a1-4611-8fcd-6e253d4f94c4.jpg",
    url: "https://fr.newchic.com/hats-and-caps-4192/p-1667386.html",
    id: "1667386",
    model: "SKUE95910",
  },
  {
    category: "accessories",
    subcategory: "Beanie Hat",
    name: "Chapeau élastique vintage en coton ethnique pour femme ",
    price: "11.49",
    raw_price: "21.71",
    currency: "USD",
    discount: "47",
    likes_count: "82",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Blue",
    variation_1_color: "Black",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/87/27/1c203e88-f46c-4166-aab7-8379f619d122.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/87/27/1c203e88-f46c-4166-aab7-8379f619d122.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/A9/C5/7e9e68e4-3ddc-476e-985e-305abc96544e.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/A9/C5/7e9e68e4-3ddc-476e-985e-305abc96544e.jpg",
    image_url: "",
    url: "https://fr.newchic.com/beanie-hat-12168/p-1669498.html",
    id: "1669498",
    model: "SKUE93185",
  },
  {
    category: "accessories",
    subcategory: "Chapeaux & Bonnets",
    name:
      "COLLROWN Couverture de protection solaire Face Visor Chapeau de pêche en plein air",
    price: "13.99",
    raw_price: "26.99",
    currency: "USD",
    discount: "48",
    likes_count: "28",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Dark Gray",
    variation_1_color: "Light Grey",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/96/2E/d9cb9ac5-be00-45a3-b450-1371d9c19ca3.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/96/2E/d9cb9ac5-be00-45a3-b450-1371d9c19ca3.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/AF/5D/eb4d6d4f-fda3-4191-b666-8adc7b9ecf5b.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/AF/5D/eb4d6d4f-fda3-4191-b666-8adc7b9ecf5b.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/68/1E/17584e5e-ee32-4474-a048-830eedb06973.jpg",
    url: "https://fr.newchic.com/hats-and-caps-4192/p-1685067.html",
    id: "1685067",
    model: "SKUF31518",
  },
  {
    category: "accessories",
    subcategory: "Cache-oreilles",
    name: "Masque Sheild visage floral vintage",
    price: "5.99",
    raw_price: "11.99",
    currency: "USD",
    discount: "50",
    likes_count: "66",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/01/96/5c322cff-87c6-4619-9f81-6310b1cb2a69.jpg",

    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/9D/58/6d00ef19-ab92-4c0f-a933-b98711158610.JPG",
    url:
      "https://fr.newchic.com/earmuffsandmouth-maskandblindfold-6010/p-1668211.html",
    id: "1668211",
    model: "SKUE94425",
  },
  {
    category: "accessories",
    subcategory: "Bucket Hat",
    name: "Chapeau mignon de chat de chapeau de modèle isolé de chat de coton",
    price: "15.25",
    raw_price: "25.99",
    currency: "USD",
    discount: "41",
    likes_count: "78",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "Khaki",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/18/A9/52e34d6e-350a-4b55-8f11-09246ee26256.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/18/A9/52e34d6e-350a-4b55-8f11-09246ee26256.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/01/96/5c322cff-87c6-4619-9f81-6310b1cb2a69.jpg",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/01/96/5c322cff-87c6-4619-9f81-6310b1cb2a69.jpg",
    url: "https://fr.newchic.com/bucket-hat-12173/p-1668909.html",
    id: "1668909",
    model: "SKUF06774",
  },
  {
    category: "accessories",
    subcategory: "Chapeaux & Bonnets",
    name: "Sun Umbrella Fishing Umbrella Headband 30CM Plastic Hat",
    price: "14.49",
    raw_price: "29",
    currency: "USD",
    discount: "50",
    likes_count: "21",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Army Green",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/F8/CF/2bd234c4-cb48-4ab4-b108-6abfa49ca089.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/F8/CF/2bd234c4-cb48-4ab4-b108-6abfa49ca089.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/9E/EC/19e83e73-1aa9-47ee-a630-2feb91ef72d6.jpg",
    url: "https://fr.newchic.com/hats-and-caps-4192/p-1665960.html",
    id: "1665960",
    model: "SKUE77201",
  },
];

export default Accessories;
